"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackingMiddleware = trackingMiddleware;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.some");

require("core-js/modules/es6.regexp.search");

require("core-js/modules/es6.regexp.match");

var _trackExperimentViewed = require("./trackExperimentViewed");

var _ActionTypes = _interopRequireDefault(require("farce/lib/ActionTypes"));

var _sharify = require("sharify");

var _get = require("../../Utils/get");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function trackingMiddleware() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (store) {
    return function (next) {
      return function (action) {
        var _options$excludePaths = options.excludePaths,
            excludePaths = _options$excludePaths === void 0 ? [] : _options$excludePaths;
        var type = action.type,
            payload = action.payload;

        switch (type) {
          case _ActionTypes.default.UPDATE_LOCATION:
            {
              var pathname = payload.pathname;
              var referrer = (0, _get.get)(store.getState(), function (state) {
                return state.found.match.location.pathname + state.found.match.location.search;
              }); // Pluck segment analytics instance from force

              var analytics = typeof window.analytics !== "undefined" && window.analytics;

              if (analytics) {
                // TODO: Pass referrer over to Artwork page if A/B test passes
                // window.sd.routerReferrer = referrer
                var foundExcludedPath = excludePaths.some(function (excludedPath) {
                  return pathname.includes(excludedPath);
                });

                if (!foundExcludedPath) {
                  var url = _sharify.data.APP_URL + pathname;
                  var trackingData = {
                    path: pathname,
                    url: url
                  };

                  if (referrer) {
                    trackingData.referrer = _sharify.data.APP_URL + referrer;
                  } // TODO: Remove after EXPERIMENTAL_APP_SHELL AB test ends.


                  if (["/collect", "/collections", "/collection/"].some(function (path) {
                    return pathname.includes(path);
                  }) && referrer) {
                    trackingData.referrer = _sharify.data.APP_URL + referrer;
                  }
                  /**
                   * Store a global reference to the referrer. Since we're in an SPA
                   * context we'll need to use this to track referrers statefully across
                   * pages, since we don't do a hard reload.
                   *
                   * Attaching to the analytics object in the absence of a more
                   * "global" location.
                   *
                   * For our new reaction apps, all tracking goes through this location:
                   * https://github.com/damassi/force/blob/399919f7ef053701f0ed3b20b32dddf0490459b0/src/desktop/assets/analytics.coffee#L41
                   * which will read __artsyReferrer and update referrer appropriately.
                   */


                  var finalReferrer = trackingData.referrer;
                  analytics.__artsyReferrer = finalReferrer;
                  analytics.page(trackingData, {
                    integrations: {
                      Marketo: false
                    }
                  }); // TODO: Remove after EXPERIMENTAL_APP_SHELL AB test ends.

                  if (_sharify.data.CLIENT_NAVIGATION_V5) {
                    (0, _trackExperimentViewed.trackExperimentViewed)("client_navigation_v5", trackingData);
                  }
                } // Reset timers that track time on page since we're tracking each order
                // checkout view as a separate page.


                var desktopPageTimeTrackers = typeof window.desktopPageTimeTrackers !== "undefined" && window.desktopPageTimeTrackers;

                if (desktopPageTimeTrackers) {
                  desktopPageTimeTrackers.forEach(function (tracker) {
                    // No need to reset the tracker if we're on the same page.
                    if (pathname !== tracker.path) {
                      tracker.reset(pathname);
                    }
                  });
                }
              }

              return next(action);
            }

          default:
            return next(action);
        }
      };
    };
  };
}
//# sourceMappingURL=trackingMiddleware.js.map